import * as React from "react";
import * as ReactDOM from "react-dom";
import PersonProfileRelationsControl, { IProps } from "./PersonProfileRelationsControl";
import { stringToIssue } from "../../../common/controls/Relations/IssueForRelations";

import { IConfig, IFieldsConfig } from "./Models";
import { WorkflowContext } from "../../ajaxWorkflowModal/WorkflowContext";

import '../../../common/controls/Relations/Relations.css';
import './PersonProfile.css';

export default function (control: HTMLDivElement, i: number) {

	var config = JSON.parse(control.dataset.config) as IConfig;
	var defaults: IFieldsConfig = {
		employee: {
			hidden: false,
			multiple: false,
			maxRows: 20,
			loadOnFocus: false,
		},
		personProfile: {
			hidden: false,
			multiple: false,
			maxRows: 20,
			loadOnFocus: false,
		},
		dateFrom: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		dateTo: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
	}
	for (var p in defaults) {
		if (!config.fields[p])
			config.fields[p] = defaults[p];
	}

	return ReactDOM.createPortal(
		<WorkflowPersonProfileResourceRelationsData
			key={"react-profile-resource-relations-data-" + i}

			issue={stringToIssue(control.dataset.issue)}

			name={control.dataset.name}
			value={control.dataset.value}
			isValidField={control.dataset.isValidField === "True"}

			defaultEmployee={control.dataset.defaultEmployee}

			forAcceptant={control.dataset.forAcceptant === "True"}
			subordinatesTree={control.dataset.subordinatesTree === "True"}

			blockInsert={control.dataset.blockInsert === "True"}
			blockEditRows={control.dataset.blockEditRows === "True"}
			blockCloneRows={control.dataset.blockCloneRows === "True"}
			blockDeleteRows={control.dataset.blockDeleteRows === "True"}
			blockChangeEmployees={control.dataset.blockChangeEmployees === "True"}

			editCurrentEmployee={control.dataset.editCurrentEmployee === "True"}

			config={config}
		/>,
		control);
};

function WorkflowPersonProfileResourceRelationsData(props: IProps) {
	return <WorkflowContext.Consumer>
		{({ issueWorkflowData, setIssueWorkflowData }) => (
			<PersonProfileRelationsControl {...props} onSet={(value) => {
				let data = { ...issueWorkflowData };
				data[props.name] = value;
				setIssueWorkflowData(data);
			}} />
		)}
	</WorkflowContext.Consumer>
}